import { databases } from '../lib/appwrite';
import { ID, Permission, Role } from 'appwrite';

const env = import.meta.env as any;
const DB_ID = env.VITE_APPWRITE_DB_ID as string;
const AUTH_EVENTS_COL_ID = env.VITE_APPWRITE_AUTH_EVENTS_COLLECTION_ID as string;

export type AuthEventDoc = {
  type: 'LOGIN' | 'LOGOUT' | 'ERROR';
  userId?: string;
  email?: string;
  provider?: 'email' | 'anonymous';
  message?: string;
  createdAt: string; // ISO
};

export const recordLoginEvent = async (account: any) => {
  if (!DB_ID || !AUTH_EVENTS_COL_ID) {
    console.warn('Auth events collection not configured: set VITE_APPWRITE_DB_ID and VITE_APPWRITE_AUTH_EVENTS_COLLECTION_ID');
    return null;
  }
  if (!account || !account.$id) {
    console.warn('No account session; skipping login audit.');
    return null;
  }
  const now = new Date().toISOString();
  const doc: AuthEventDoc = {
    type: 'LOGIN',
    userId: account.$id,
    email: account.email ?? undefined,
    provider: account?.email ? 'email' : 'anonymous',
    createdAt: now,
  };
  const perms = [
    Permission.read(Role.user(account.$id)),
    Permission.write(Role.user(account.$id)),
  ];
  return await databases.createDocument(DB_ID, AUTH_EVENTS_COL_ID, ID.unique(), doc, perms);
};

export const recordLogoutEvent = async (account: any) => {
  if (!DB_ID || !AUTH_EVENTS_COL_ID) return null;
  const now = new Date().toISOString();
  const doc: AuthEventDoc = {
    type: 'LOGOUT',
    userId: account?.$id,
    email: account?.email ?? undefined,
    provider: account?.email ? 'email' : 'anonymous',
    createdAt: now,
  };
  const perms = account?.$id ? [
    Permission.read(Role.user(account.$id)),
    Permission.write(Role.user(account.$id)),
  ] : undefined;
  return await databases.createDocument(DB_ID, AUTH_EVENTS_COL_ID, ID.unique(), doc, perms);
};